<swiper-container
  slides-per-view="1"
  space-between="20"
  #swiper
  (swiperslidechange)="index=swiper.swiper.realIndex"
>
  @for (image of images; track $index) {
  <swiper-slide lazy="false">
    <img
      [ngSrc]="image|fileurl"
      fill
      (click)="preview($index)"
      alt="product image {{$index}}"
    />
  </swiper-slide>
  }
</swiper-container>
<mat-icon
  class="prev"
  fontSet="material-symbols-outlined"
  inline
  (click)="swiper.swiper.slidePrev()"
  >chevron_left</mat-icon
>
<mat-icon
  class="next"
  fontSet="material-symbols-outlined"
  inline
  (click)="swiper.swiper.slideNext()"
  >chevron_right</mat-icon
>

<div class="pagination">
  @for (image of images; track $index) {
  <div
    class="bullet"
    [ngClass]="{'active':$index===index}"
    (click)="swiper.swiper.slideTo($index)"
  ></div>
  }
</div>
